/**
 * Seiten und Rechteprüfung der SPA-Kopfzeile. `hatRecht`, `SEITEN_RECHTE` und `ersteErlaubteSeite`
 * sind Nachportierungen nach Regel 1 (Phase-Plan, Abschnitt "Zwei Regeln") - `index.html` hat sie
 * nie in `src/lib/` gebraucht, weil Phase 2b keine Kopfzeile portierte. Sie stehen bewusst in
 * `src/state/` statt `src/lib/`: sie sind kein Teil der wiederverwendbaren Fachlogik-Bibliothek
 * (Rechnen, Formatieren, Statusableitung), sondern SPA-eigener Navigationszustand ohne Gegenstück
 * in einem eigenständigen `lib/`-Modul. `test/parity/berechtigungen.test.ts` hält sie trotzdem
 * wortgleich gegen `index.html` - das erfüllt den Differenztest-Teil von Regel 1; der
 * `gen:herkunft`-Zähler (129 Symbole) bleibt unverändert, weil er ausschließlich die in Phase 2b
 * portierten `src/lib/`- und `src/config/`-Module führt (siehe `scripts/gen-herkunft.ts`, `MODULE`),
 * zu denen `state/` nie gehörte.
 */

/**
 * Die fünf über die Navigation erreichbaren Seiten plus `users` (nur über das Marken-Menü, nicht
 * über `nav > button`, index.html:3671-3677 zeigt keinen `nav-users`-Reiter).
 */
export type Seite = "board" | "timeline" | "overview" | "payments" | "costs" | "users";

/**
 * 1:1 zu `PAGE_PERMISSIONS` (`index.html:5278-5281`).
 */
export const SEITEN_RECHTE: Readonly<Record<Seite, string>> = {
  board: "view_board",
  timeline: "view_timeline",
  overview: "view_overview",
  payments: "view_payments",
  costs: "view_costs",
  users: "manage_users",
};

/**
 * 1:1 zu `hasPermission` (`index.html:5302-5304`): `recht` darf eine Liste sein, dann genügt eine
 * der genannten Berechtigungen ("eines davon genügt").
 */
export function hatRecht(rechte: ReadonlySet<string>, recht: string | readonly string[]): boolean {
  return [recht].flat().some((eintrag) => rechte.has(eintrag));
}

/**
 * 1:1 zu `firstAllowedPage` (`index.html:5306-5308`): Reihenfolge board, timeline, overview,
 * payments, costs (ohne `users` - dieselbe Auslassung wie im Original), Rückfall `board`.
 */
export function ersteErlaubteSeite(rechte: ReadonlySet<string>): Seite {
  const REIHENFOLGE = ["board", "timeline", "overview", "payments", "costs"] as const;
  return REIHENFOLGE.find((seite) => hatRecht(rechte, SEITEN_RECHTE[seite])) ?? "board";
}
